(() => {
  const sales = new Set(['ready-to-press-transfers','premade-gang-sheets','uv-dtf-stickers','heat-press-patches','wholesale']);
  function init(root) {
    if (root.dataset.s2tJournalReady) return;
    root.dataset.s2tJournalReady = 'true';
    const filter = root.querySelector('[data-s2t-topic-filter]');
    if (filter) { filter.hidden = false; filter.querySelector('select').addEventListener('change', (event) => { location.href = event.target.value; }); }
    const body = root.querySelector('[data-s2t-article-content]');
    if (!body) return;
    const title = root.querySelector('h1').textContent.trim();
    const headings = [...body.querySelectorAll('h2')].filter((heading, index) => {
      if (!heading.textContent.trim() || (index === 0 && heading.textContent.trim() === title)) { heading.hidden = true; return false; }
      return true;
    });
    const toc = root.querySelector('[data-s2t-toc]');
    if (headings.length > 1) {
      const list = toc.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) { let id = 'article-section-' + (index + 1); while (document.getElementById(id)) id += '-section'; heading.id = id; }
        const li = document.createElement('li'); const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id); link.textContent = heading.textContent.trim(); li.append(link); list.append(li);
        link.addEventListener('click', () => { heading.tabIndex = -1; heading.focus({preventScroll:true}); });
      });
      toc.hidden = false; toc.open = matchMedia('(min-width: 1024px)').matches;
    }
    body.querySelectorAll('a[href]').forEach((link) => {
      let url; try { url = new URL(link.getAttribute('href'), location.href); } catch { return; }
      if (!['http:', 'https:'].includes(url.protocol) || (url.origin === location.origin && url.pathname === location.pathname && url.hash)) return;
      const shopping = url.origin === location.origin && (url.pathname === '/' || /^\/(products|collections|cart|search)(\/|$)/.test(url.pathname) || sales.has(url.pathname.replace(/^\/pages\//,'').replace(/\/$/,'')));
      if (shopping) { link.removeAttribute('target'); return; }
      link.target = '_blank'; link.rel = [...new Set((link.rel + ' noopener').trim().split(/\s+/))].join(' ');
      const notice = document.createElement('span'); notice.className = 's2t-sr-only'; notice.textContent = ' (opens in a new tab)'; link.append(notice);
    });
  }
  const scan = () => document.querySelectorAll('[data-s2t-journal]').forEach(init);
  scan(); document.addEventListener('shopify:section:load', scan);
})();
